/*==========================================
=            Trip Planner Store            =
==========================================*/

// imports
import settings from '../../config/index'
import utils from '../../helpers/utils'
import { modeIcons } from '../../helpers/common'
import VueScrollTo from 'vue-scrollto'


// Store, this is the single source of truth that powers the application
const state = {
  ajaxLoading: {
    'all-routes': false,
    'bus-routes': false,
    'lightrail-routes': false,
    'trip-planner': false
  }
}

// mutations calls are sync operations and are the only place that the store can be updated.
const mutations = {
  SET_AJAX_LOADING (state, payload) {
    state.ajaxLoading[payload.key] = payload.loading
  },

}

// For async operations use actions, used mostly with ajax calls
const actions = {

  // for OTP get trips
  getTripsOTP ({ commit, state }, current = false ) {

  },

}

// Getters are a way to grab computed data from the store
const getters = {
  ajaxLoading: state => state.ajaxLoading,
 }

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/routes.js